var _style, _circle, _path, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPh(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F0F0F0;}\n\t.st1{fill:#D80027;}\n\t.st2{fill:#0052B4;}\n\t.st3{fill:#FFDA44;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 256,
    cy: 256,
    r: 256
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M256,0v256L75,437c46.3,46.3,110.3,75,181,75c141.4,0,256-114.6,256-256S256,0,256,0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M256,0C185.3,0,121.3,28.7,75,75c62.8,62.8,85.1,85.1,181,181h256C512,114.6,397.4,0,256,0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M175.3,256L144,241.3l16.6-30.3l-33.9,6.5l-4.3-34.3l-23.6,25.2l-23.6-25.2l-4.3,34.3L36.9,211l16.6,30.3 L22.3,256l31.3,14.7L36.9,301l34-6.5l4.3,34.3l23.6-25.2l23.6,25.2l4.3-34.3l33.9,6.5L144,270.7L175.3,256z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M68.3,100.2l10.4,14.5l17-5.4l-10.6,14.4l10.4,14.5l-17-5.7L67.9,147l0.1-17.9l-17-5.7l17-5.4L68.3,100.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M68.3,365l10.4,14.5l17-5.4l-10.6,14.4l10.4,14.5l-17-5.7l-10.6,14.4l0.1-17.9l-17-5.7l17-5.4L68.3,365z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M216.7,232.6l-10.4,14.5l-17-5.4l10.6,14.4l-10.4,14.5l17-5.7l10.6,14.4l-0.1-17.9l17-5.7l-17-5.4L216.7,232.6 z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPh);
export default __webpack_public_path__ + "static/media/ph.95df6de3e20262116d8277ad7ce7738d.svg";
export { ForwardRef as ReactComponent };